export default {
  methods: {
    $uiKeyDown(key) {
      return !!this.$store.state.ui.keys[key]
    },
  },
}
